import axios from 'axios';
import {
    ApiDepot,
    AxiosApiResponse,
    ExtentParams,
    PaginationMetadata,
    PaginationParams
} from '~/api/types';
import constants from '~/utils/constants';

/**
 * Implementations of the API methods under the `/depots` path
 *
 * @category API
 */

type GetDepotsParams = PaginationParams | ExtentParams;

export default class DepotsApi {
    /**
     * Path of the API endpoint
     */
    private static readonly depotsPath = '/depots';

    private static readonly depotPath = '/depot';

    static get(
        clientId: string,
        params: GetDepotsParams = {
            limit: 1000,
            extent: 'address'
        }
    ): Promise<AxiosApiResponse<ApiDepot, PaginationMetadata>> {
        return axios.get(this.depotsPath, {
            params,
            headers: clientId
                ? {
                      [constants.requestHeaders.WISE_CLIENT_IDS]: [
                          JSON.stringify([clientId])
                      ]
                  }
                : {}
        });
    }

    static post(payload: {
        address: string;
    }): Promise<AxiosApiResponse<ApiDepot>> {
        return axios.post(this.depotPath, payload);
    }

    static delete(id: string): Promise<AxiosApiResponse<ApiDepot>> {
        if (!id) {
            return Promise.reject('depot id not provided');
        }
        return axios.delete(`${this.depotPath}/${id}`);
    }
}
